import React from "react";
import useTranslation from "../../../hooks/use-translation";
import { isDeviceMobile } from "../../../libs/auth.helper";
const GeneralTips = ({ tips }) => {
    const { translate } = useTranslation();
    return (React.createElement("div", { className: `w-100 px-5 ${!isDeviceMobile() && 'pe-2'} py-3` },
        tips.length > 0 && React.createElement("div", { className: "w-100 p-2 d-flex", style: { paddingBottom: "15px", border: '1px dashed red', borderRadius: '15px' } },
            React.createElement("span", { className: 'py-1 rounded-circle mx-1 text-center', style: { backgroundColor: '#FF0001', height: '24px', width: '24px' } },
                React.createElement("i", { className: "fa-solid fa-exclamation text-white fs-4" })),
            React.createElement("div", { className: "mx-1 w-100" },
                React.createElement("div", { className: "text-start fs-4 fw-bold" }, translate("general-tips")),
                React.createElement("ul", { className: "m-0 px-5 fs-6" }, tips.map(tip => {
                    return (React.createElement("li", { className: 'text-dark text-start' }, tip));
                })))),
        tips.length === 0 && React.createElement("div", { className: "w-100 tips-holder" })));
};
export default GeneralTips;
